import {
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
  Link,
  Divider,
} from '@mui/material';
import {
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  YouTube as YouTubeIcon,
  LinkedIn as LinkedInIcon,
} from '@mui/icons-material';
import { ThemeProvider } from '@mui/material/styles';
import { getAppTheme } from '../../services/authContext';

// --- FOOTER COMPONENT ---
const Footer = () => {
  const theme = getAppTheme('light'); // Or 'dark' based on your app's state

  const navLinks = [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about' },
    { label: 'Blog', path: '/blog' },
    { label: 'Calculators', path: '/calc' },
    { label: 'Contact', path: '/contact' },
  ];

  const legalLinks = [
    { label: 'Privacy Policy', path: '/privacy' },
    { label: 'Terms & Conditions', path: '/terms' },
  ];

  return (
    <ThemeProvider theme={theme}>
      <Box
        component="footer"
        sx={{
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.secondary,
          py: 6,
          borderTop: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={5}>
            {/* Column 1: Brand Info */}
            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <img src="/mle.jpg" alt="Logo" style={{ width: '40px', height: '40px', marginRight: '12px' }} />
                <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>
                  Make Loan Eazy
                </Typography>
              </Box>
              <Typography variant="body2" sx={{ mb: 2 }}>
                Your trusted partner in financial clarity. We simplify complexity, so you can choose with confidence.
              </Typography>
              <Box>
                <IconButton href="#" aria-label="Facebook" sx={{ color: 'text.secondary' }}>
                  <FacebookIcon />
                </IconButton>
                <IconButton href="#" aria-label="Twitter" sx={{ color: 'text.secondary' }}>
                  <TwitterIcon />
                </IconButton>
                <IconButton href="#" aria-label="YouTube" sx={{ color: 'text.secondary' }}>
                  <YouTubeIcon />
                </IconButton>
                <IconButton href="#" aria-label="LinkedIn" sx={{ color: 'text.secondary' }}>
                  <LinkedInIcon />
                </IconButton>
              </Box>
            </Grid>

            {/* Column 2: Quick Links */}
            <Grid item xs={6} sm={4} md={2}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: theme.palette.text.primary, mb: 2 }}>
                Quick Links
              </Typography>
              {navLinks.map((link) => (
                <Link href={link.path} key={link.label} color="inherit" underline="hover" display="block" sx={{ mb: 1 }}>
                  {link.label}
                </Link>
              ))}
            </Grid>

            {/* Column 3: Legal */}
            <Grid item xs={6} sm={4} md={2}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: theme.palette.text.primary, mb: 2 }}>
                Legal
              </Typography>
              {legalLinks.map((link) => (
                <Link href={link.path} key={link.label} color="inherit" underline="hover" display="block" sx={{ mb: 1 }}>
                  {link.label}
                </Link>
              ))}
            </Grid>

            {/* Column 4: Contact Info */}
            <Grid item xs={12} sm={4} md={4}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: theme.palette.text.primary, mb: 2 }}>
                Get in Touch
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                LG-1330 Sec-46, Gurgaon, Haryana
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Email: contact@makeloaneazy.com
              </Typography>
              <Typography variant="body2">
                Phone: +91 9266961818
              </Typography>
            </Grid>
          </Grid>

          <Divider sx={{ my: 4 }} />

          <Typography variant="body2" align="center">
            Copyright © {new Date().getFullYear()} Make Loan Eazy. All Rights Reserved.
          </Typography>
        </Container>
      </Box>
    </ThemeProvider>
  );
};


export default Footer;
